import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-synoptic-action-item',
    templateUrl: './synoptic-action-item.component.html',
})
export class SynopticActionItemComponent {
    public readonly action = output<void>();
    public readonly disabled = input<boolean>(false);
    public readonly icon = input<IconProp>(['fad', 'empty-set']);
    public readonly label = input.required<string>();
    public readonly matTooltip = input<string>('');

    protected emitAction(): void {
        if (this.disabled()) {
            return;
        }

        this.action.emit();
    }
}
